import { CommonModule } from "@angular/common";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { translationChunksConfig } from "@spartacus/assets";
import { I18nModule, ConfigModule, CmsConfig, provideConfig, BaseSiteService } from "@spartacus/core";
import { NeedToGoBackModule } from "../shared/modules/need-to-go-back/need-to-go-back.module";
import { VaxContactUsComponent } from "./vax-contact-us/vax-contact-us.component";
import {
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings, RECAPTCHA_SETTINGS
} from 'ng-recaptcha';
import { take } from "rxjs/operators";
const globalSettings: RecaptchaSettings = {
  siteKey: '',
};

function loadRecaptcha(baseSiteService: BaseSiteService) {
  return () => baseSiteService.get().pipe(take(1)).subscribe((baseSite: any) => {
    globalSettings.siteKey = baseSite?.captchaConfig?.publicKey;
  })
}

@NgModule({
  declarations: [VaxContactUsComponent],
  imports: [
    CommonModule,
    I18nModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    RouterModule,
    BrowserAnimationsModule,
    NeedToGoBackModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        VaxServeContactUsPageBodyComponent:{
          component:VaxContactUsComponent
        }

      },
    } as CmsConfig),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      deps: [BaseSiteService],
      useFactory: loadRecaptcha,
      multi: true,
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: globalSettings,
    },
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class VaxAboutContactUsModule { }
